// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



import IconSVG from 'svg-inline-react'

import PropTypes from 'prop-types'

import 'styles/components/customer/Location.styl'

const Location = React.createClass({
  propTypes: {
    locationString: PropTypes.string
  },

  render() {
    return (
      <div className="Location">
        {this.props.locationString ?
        [
          <IconSVG
            src={require('!svg-inline?removeTags=true!images/icons/location-icon.svg')} />,
          this.props.locationString
        ] : undefined}
      </div>
    )
  }
})

export default Location



// WEBPACK FOOTER //
// ./src/scripts/components/customer/Location.js